import React from "react";
import Box from "@mui/material/Box";
import { keyframes } from "@mui/system";

const MAX_WIDTH = 400;

const TILE_COLORS = {
  2: "#abc9eb",
  4: "#89aed8",
  8: "#6999cf",
  16: "#4c83c2",
  32: "#4ca6c2",
  64: "#59b8a7",
  128: "#82b879",
  256: "#b6bf73",
  512: "#baa5d9",
  1024: "#e0a580",
};

function getTileColor(value) {
  return TILE_COLORS[Number(value)] || "#fff";
}

const GameBoard = ({ board, onDrop, numCols }) => {
  // Transpose the board to get columns
  const columns = Array.from({ length: numCols }, (_, colIdx) =>
    board.map((row) => row[colIdx])
  );

  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: `repeat(${numCols}, 1fr)`,
        columnGap: 1,
        rowGap: 0.5,
        width: "100%",
        maxWidth: "sm",
        background: "transparent",
        mx: "auto",
      }}
    >
      {columns.map((colCells, colIdx) => (
        <Box
          key={colIdx}
          onClick={() => onDrop(colIdx)}
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-end",
            cursor: "pointer",
            borderRadius: 2,
            transition: "box-shadow 0.2s, background 0.2s",
            minHeight: 320,
            position: "relative",
            overflow: "visible",
            "&:hover": {
              boxShadow: "0 0 0 2px rgba(127, 214, 247, 0.3)",
            },
            "&:active": {
              boxShadow: "0 0 0 2px rgba(127, 214, 247, 0.5)",
            },
          }}
        >
          {colCells.map((cell, rowIdx) => (
            <Box
              key={rowIdx}
              sx={{
                position: "relative",
                width: "100%",
                paddingTop: "85%", // slightly less tall
                zIndex: 2,
              }}
            >
              <Box
                sx={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontWeight: 700,
                  fontSize: 22,
                  color: "#222",
                  background: cell ? getTileColor(cell) : "#fff",
                  borderRadius: 1,
                  boxShadow: cell
                    ? "0 4px 16px 0 rgba(145,178,209,0.18)"
                    : "0 2px 8px 0 rgba(0,0,0,0.06)",
                  border: cell ? "2.5px solid #7fd6f7" : "1.5px solid #ddd",
                  transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                }}
              >
                {cell || ""}
              </Box>
            </Box>
          ))}
        </Box>
      ))}
    </Box>
  );
};

export default GameBoard;
